export enum LayoutTypes {
  BARE,
  INSTITUTIONAL,
  DASHBOARD
}
